import React from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import basicServiceDetailsStyles from "./BasicServiceDetailsStyles";

import { getServiceIdFromServiceList } from "../../../../utils/helperFunctions";
import PropTypes from "prop-types";
import FulfillmentSection from "../../../../components/common/FulfillmentSection";

const BasicServiceDetails = ({
  serviceTypeName,
  servicePropositionList,
  displayName,
  posDetails,
  errors,
}) => {
  const classes = basicServiceDetailsStyles();

  const serviceTypeId = getServiceIdFromServiceList(servicePropositionList, serviceTypeName);

  return (
    <Accordion defaultExpanded={false} className={classes.accordionStyle}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={classes.accordionSummaryStyle}
      >
        <Typography align="left" className={classes.cardTitle}>
          {displayName || serviceTypeName || ""}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetailsStyle}>
        <Grid container spacing={3} className={classes.detailsContainer}>
          <Grid item xs={12}>
            <FulfillmentSection
              posDetails={posDetails}
              errors={errors}
              serviceTypeId={serviceTypeId}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

BasicServiceDetails.propTypes = {
  serviceTypeName: PropTypes.string,
  servicePropositionList: PropTypes.array,
  displayName: PropTypes.string,
  posDetails: PropTypes.object,
  errors: PropTypes.object,
};

export default React.memo(BasicServiceDetails);
